import { React, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import axios from "axios";
import dayjs from "dayjs";
import "./TripInput.css";
import { ReactComponent as WorldIcon } from "../../assets/world-icon.svg";
import { ReactComponent as CalendarIcon } from "../../assets/calendar-icon.svg";
import DatePickerValue from "../date-picker/DatePicker";

function TripInput({ postRoute, initialData = {} }) {
  const { register, handleSubmit, control, reset } = useForm({
    defaultValues: {
      name: "",
      destination: "",
      startDate: dayjs(),
      endDate: dayjs(),
    },
  });
  useEffect(() => {
    if (initialData) {
      reset({
        name: initialData.TRIP_NAME || "",
        destination: initialData.DESTINATION || "",
        startDate: initialData.START_DATE
          ? dayjs(initialData.START_DATE)
          : dayjs(),
        endDate: initialData.END_DATE ? dayjs(initialData.END_DATE) : dayjs(),
      });
    }
  }, [initialData, reset]);
  const [errorMessage, setErrorMessage] = useState(null);
  const navigate = useNavigate();
  const onFormSubmit = async (data) => {
    try {
      const formattedData = {
        ...data,
        startDate: data.startDate ? data.startDate.format("YYYY-MM-DD") : null,
        endDate: data.endDate ? data.endDate.format("YYYY-MM-DD") : null,
      };
      const response = await axios.post(postRoute, formattedData);
      const newId = response.data.id;
      navigate(`/saved-trip/${newId}`, { state: formattedData });
    } catch (err) {
      console.log("Logging error:", err.response?.data || err.message);
      console.error("Error:", err.response?.data || err.message);
      setErrorMessage(
        err.response?.data?.error || "An unexpected error occurred."
      );
    }
  };
  const onErrors = (errors) => console.error(errors);

  return (
    <>
      <div className="trip-input-container">
        <form
          className="trip-text"
          onSubmit={handleSubmit(onFormSubmit, onErrors)}
        >
          <div className="input-field">
            <label>
              Trip name:
              <input
                type="text"
                name="name"
                {...register("name")}
                placeholder="New Trip"
              />
            </label>
          </div>
          <h2 className="trip-input-heading">Destination</h2>
          <WorldIcon />
          <div className="input-field">
            <label>
              Going to:
              <input
                type="text"
                name="destination"
                {...register("destination")}
              />
            </label>
          </div>
          <h2 className="trip-input-heading">Dates</h2>
          <CalendarIcon />
          <div className="input-field">
            <label>
              From:
              <Controller
                name="startDate"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <DatePickerValue
                    value={field.value}
                    onChange={field.onChange}
                    error={error}
                  />
                )}
              />
            </label>
            <div className="to-input">
              <label className="to-input">
                To:
                <Controller
                  name="endDate"
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <DatePickerValue
                      value={field.value}
                      onChange={field.onChange}
                      error={error}
                    />
                  )}
                />
              </label>
            </div>
          </div>
          <p className="error">{errorMessage}</p>
          <input type="submit" value="Save" />
        </form>
      </div>
    </>
  );
}

export default TripInput;
